var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "pb-0 pa-0 mt-0",
      attrs: { outlined: "", "max-height": "350" },
    },
    [
      _c(
        "v-app-bar",
        { staticClass: "elevation-0", attrs: { dense: "" } },
        [
          _c("v-toolbar-title", { staticClass: "text-body-1 mt-4" }, [
            _c("p", [_c("strong", [_vm._v(_vm._s(_vm.title))])]),
          ]),
        ],
        1
      ),
      _c("v-divider", { staticClass: "mb-2" }),
      _vm.loading
        ? _c("v-progress-linear", {
            attrs: { indeterminate: "", color: "yellow darken-2" },
          })
        : _vm._e(),
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            _vm._l(_vm.items, function (item, i) {
              return _c(
                "v-col",
                { key: i, attrs: { cols: "12", sm: "2" } },
                [
                  _vm.renderComponent
                    ? _c("v-text-field", {
                        staticClass: "ml-0 centered-input text--darken-3 mt-3",
                        staticStyle: { "text-align": "center" },
                        attrs: {
                          id: "text" + i,
                          value: item,
                          regular: "",
                          dense: "",
                          disabled: _vm.disabled,
                        },
                        on: {
                          keydown: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.keydown($event, i)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }